import angular from 'angular';
import SplitBtnComponent from './split-btn.component';

const SplitBtnModule = angular
    .module('control-room.commons.basic.components.split-btn', [])
    .component('crSplitBtn', SplitBtnComponent);

export default SplitBtnModule;
